import { useMemo } from 'react';
import { QueryParams } from 'shared/types';
import { PriceTypeLogic } from '../models';
import useFetchByParams from '../../../shared/hooks/useFetchByParams';
import { fetchPriceTypeLogics, selectPriceTypeLogics } from 'features/products/store/price.slice';

export const usePriceTypeLogicQuery = (
  query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query };

    return [queryParams];
  }, []);
};

export const usePriceTypeLogics = (query: any) => {
   return useFetchByParams<PriceTypeLogic[]>({
    action: fetchPriceTypeLogics,
    dataSelector: selectPriceTypeLogics,
    params: query,
  });
};
